const Provider = require("./Provider");
const PropTypes = require("prop-types");
const {observable} = require("mobx");
const router = require("services/router");
const {toQueryString} = require("helpers/url");
const {decodeObservable} = require("helpers/object");
const assign = require("object-assign");
const shortid = require("shortid");

class Context extends Provider {

    @observable params = {};

    constructor(props) {
        super(props);

        if(this.props.default){
            this.params = this.props.default;
        }

    }


    componentDidUpdate(prevProps) {
        if (prevProps.default !== this.props.default) {
            this.params = this.props.default;
            this.updateUuid();
        }
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    resolve() {
        if(this.props.context){
            return this.props.context;
        }
        return this;
    }

    get providerProps() {
        return {
            context: this.resolve()
        };
    }

    /////////////////////////////////
    // Private methods
    /////////////////////////////////

    _assign(obj) {
        const old = JSON.parse(JSON.stringify(this.params));
        this.params = (typeof obj === "function") ?
            obj(old) :
            assign(old, obj);
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    checkStep(name) {
        return this.params.step && this.params.step === name;
    }

    checkState(name) {
        return this.params.state && this.params.state === name;
    }

    startEditing = (resource, id = null) => {
        this._assign(params => {
            delete params[resource];
            delete params.state;
            delete params.edit_uuid;

            params.state = 'editing';
            params.edit_uuid = shortid.generate();
            params[resource] = id;

            return params;
        });
    }

    stopEditing = (resource) => {
        this._assign(params => {
            delete params[resource];
            delete params.state;
            delete params.edit_uuid;

            return params;
        });
    }

}

module.exports = Context;